import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://ajkoefjlhpgtatrrfewt.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_WiMjZB5rmXJ8Fm4fcWnhRA_yZhIZ7JV';

// Explicit auth options so the session survives app restarts on iOS —
// these are the library defaults, but stating them guards against
// future library changes and makes the intent clear.
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
  },
});
